export default __webpack_public_path__ + "static/media/23.4e93540a.png";